import { Pipe, PipeTransform } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { MarketplacePackagesApiService, Product } from '@vendasta/marketplace-packages';
import { FulfillmentOrder } from '@vendasta/order-fulfillment';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'getProductInfo',
  standalone: false,
})
export class GetProductInfoPipe implements PipeTransform {
  #productInfoCache: Map<string, Product> = new Map();

  constructor(private marketplacePackagesApiService: MarketplacePackagesApiService) {}

  transform(fulfillmentOrder?: FulfillmentOrder): Observable<Product> {
    if (!fulfillmentOrder) {
      return of(null);
    }
    const productFromCache: Product = this.#productInfoCache.get(fulfillmentOrder.appId);
    if (productFromCache) {
      return of(productFromCache);
    }
    return this.marketplacePackagesApiService
      .getMultiProducts({
        partnerId: fulfillmentOrder.resellerPartnerId,
        productIds: [fulfillmentOrder.appId],
      })
      .pipe(
        map((products) => products?.products[0]?.product),
        tap((product) => this.#productInfoCache.set(fulfillmentOrder.appId, product)),
      );
  }
}
